export default __webpack_public_path__ + "static/media/FeverInTheOceans_00.5c17018c.png";